import { Menu } from '@pickleballinc/react-ui';
import { MenuItem } from '@pickleballinc/react-ui/Menu/MenuItem';

export const LeaguePlayerRankingsDropdown = () => {
	const menuItemStyle = `flex h-6 cursor-pointer items-center justify-start rounded-md py-1 pl-2 pr-2.5 text-sm font-medium leading-5 !outline-none hover:bg-purple-100`;

	return (
		<>
			<Menu.List className="w-[180px] rounded-lg border-none">
				<MenuItem className={`${menuItemStyle} text-gray-900`}>Division 3.0</MenuItem>
				<hr className="bg-gray-200" />
				<MenuItem onClick={() => {}} className={`${menuItemStyle} text-gray-500`}>
					Division 4.0
				</MenuItem>
				<hr className="bg-gray-200" />
				<MenuItem onClick={() => {}} className={`${menuItemStyle} text-gray-500`}>
					Division 5.0
				</MenuItem>
			</Menu.List>
		</>
	);
};
